import { render } from "./SendEmailSupportPage.vue?vue&type=template&id=419ecdad&scoped=true"
import script from "./SendEmailSupportPage.vue?vue&type=script&lang=js"
export * from "./SendEmailSupportPage.vue?vue&type=script&lang=js"

import "./SendEmailSupportPage.vue?vue&type=style&index=0&id=419ecdad&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419ecdad"]])

export default __exports__